// extracted by mini-css-extract-plugin
module.exports = {"flexbox":"styles_flexbox__2kaG5","defaultSpacing":"styles_defaultSpacing__39oFK","relativeBox":"styles_relativeBox__CfavM","marginUnset":"styles_marginUnset__2XVGR"};